module.exports = __webpack_public_path__ + "static/img/BRAD_HOGG.47b9c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BRAD_HOGG.jpg
// module id = ktVy
// module chunks = 0